import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { HomeLayout } from "../../home/Layout";
import { ToolBar } from "../../../modules/home/ToolBar";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAllTeamsData } from "../../../redux/slices/teamSlice";
import { getAllTeamsOfTeamLead } from "../../../redux/slices/TeamLeadTeams";

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: "left",
    padding: theme.spacing(6, 6, 2, 5),
    marginTop: theme.spacing(6.5),
    background: "#F5F6FA",
    height: "-webkit-fill-available",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 4, 6, 4),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(11.25),
      padding: theme.spacing(5, 3, 3, 3),
    },
  }
}));

export const TeamsLayout = ({
  props,
  loading,
  setLogout,
  isDetailView,
  setIsDetailView,
  renderErrorModal,
  renderSearchBox,
  renderTeamsList,
  renderChangePageButtons,
  count,
  renderNewTeamButton,
}) => {
  document.title = "Grow-Wize | Admin - Teams";
  const classes = useStyle();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const tempFunction = () => {
    return 0;
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (currentPath === "/admin/teams") {
      dispatch(getAllTeamsData());
    } else if (currentPath === "/teams") {
      dispatch(getAllTeamsOfTeamLead());
    }
  }, []);

  const renderToolBar = () => (
    <ToolBar
      headerName="Teams"
      setLogout={setLogout}
      isDetailView={isDetailView}
      setIsDetailView={setIsDetailView}
      handleDrawerToggle={handleDrawerToggle}
      value={-2}
      setValue={tempFunction}
      tabValue={-2}
      validLength={false}
    ></ToolBar>
  );

  const renderTeamsLayout = () => (
    <>
      {renderErrorModal()}
      <Grid container direction="row" className={classes.root} justify="center">
        <Grid
          container
          direction="column"
          alignItems="flex-start"
          style={{ width: "inherit" }}
        >
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {renderSearchBox()}
            {renderNewTeamButton()}
          </Grid>
          {renderTeamsList()}
          {count !== 0 ? renderChangePageButtons() : null}
        </Grid>
      </Grid>
    </>
  );

  return (
    <HomeLayout
      loading={loading}
      renderToolBar={renderToolBar}
      props={props}
      mobileOpen={mobileOpen}
      handleDrawerToggle={handleDrawerToggle}
      renderSelectedOption={renderTeamsLayout}
    ></HomeLayout>
  );
};
